import { CityCatalogStatsResponse } from '@common/model/catalog/item/cityStatsRequest';
import { CityViewModel } from '@common/model/location/cityViewModel';
import { useCurrentCity } from '@cp/entities/location';
import { coreCatalogApi } from '@cp/entities/catalog';

export const useCatalogStats = (): CityCatalogStatsResponse | undefined => {
  const { currentCity } = useCurrentCity({ allowEmptyValue: true });

  const { data } = coreCatalogApi.endpoints.getItemsCityStats.useQuery(
    { cityId: currentCity?.id as CityViewModel['id'] },
    { skip: !currentCity },
  );

  return data;
};
